<lib-medecin-direct *ngIf="showMedecinDirect"></lib-medecin-direct>